import { NormalizedFuelPrice } from '@/types/price-comparison.types';

import '../BrandSummaryTable/PriceComparisonTables.css';
import { StationDetailsTableProps } from './StationDetailsTable.types';
import { PriceComparisonCell } from '../PriceComparisonCell';

/**
 * Renders a detailed table showing station-level price comparison data
 * Displays station unicode, division, region, province, brand, address, and fuel prices
 * Responsive layout with mobile-optimized header display
 *
 * @param props - The component props
 * @returns JSX element containing the station details table or null if no data
 */
export function StationDetailsTable({ stationDetails, fuelTypes, isMobile, scrollRef }: StationDetailsTableProps) {
  if (stationDetails.length === 0) return null;

  return (
    <div className="price-comparison-stations-container">
      <div className="price-comparison-stations-table-wrapper" ref={scrollRef}>
        <table className={`price-comparison-table ${isMobile ? 'mobile-table' : ''}`}>
          <tbody>
            {stationDetails.map((station, index) => (
              <tr
                key={`${station.brand}-${station.unicode}-${station.address}-${index}`}
                className={`price-comparison-table-row price-comparison-station-row ${station.is_reference ? 'okko-station' : ''}`}
              >
                <td className="price-comparison-table-cell price-comparison-unicode-cell price-comparison-col-unicode">
                  {station.unicode}
                </td>
                <td className="price-comparison-table-cell price-comparison-col-division">{station.division || '-'}</td>
                <td className="price-comparison-table-cell price-comparison-col-region">{station.region || '-'}</td>
                <td className="price-comparison-table-cell price-comparison-col-province">{station.province || '-'}</td>
                <td className="price-comparison-table-cell price-comparison-brand-cell price-comparison-col-brand">
                  {station.brand}
                </td>
                <td
                  className="price-comparison-table-cell price-comparison-address-cell price-comparison-col-address"
                  title={station.address}
                >
                  {station.address}
                </td>
                {fuelTypes.map(fuel => {
                  const stationFuelPrice = station.fuel_prices[fuel.fuel_type];
                  const normalizedPrice: NormalizedFuelPrice | null = stationFuelPrice
                    ? {
                        actual_price: stationFuelPrice.actual_price || undefined,
                        difference_from_mode: stationFuelPrice.difference_from_mode || undefined
                      }
                    : null;
                  return (
                    <td
                      key={fuel.fuel_type}
                      className="price-comparison-table-cell price-comparison-price-cell price-comparison-col-fuel"
                    >
                      <PriceComparisonCell fuelPrice={normalizedPrice} brandName={station.brand} isSummary={false} />
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
